import { ReactComponent as ArrowBackIos } from '../../../../assets/icons/arrow-back-ios.svg';

export { ArrowBackIos };
